"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorEnum = void 0;
var VectorEnum;
(function (VectorEnum) {
    VectorEnum["Push"] = "push";
    VectorEnum["Pull"] = "pull";
    VectorEnum["Static"] = "static";
})(VectorEnum = exports.VectorEnum || (exports.VectorEnum = {}));
//# sourceMappingURL=vector.enum.js.map